import React from "react";
import { useFormContext } from "react-hook-form";
import { FormSection } from "../../../../../../Common/__styles__/Modal";
import { Title } from "../../../../../../Common/Typography";
import { Label } from "../../../../../../Inputs";
import { Radio, Text } from "../../../../../../Inputs/react-hook-form";
import { SelectedSubmissionsBuilderField } from "../../reducer";
import {
  SubmissionsBuilderFieldSettings,
  SubmissionsBuilderFormDataStructure,
} from "../../types";
import { FormSectionTitleWrapper } from "../__styles__/SidebarColumn";
import { WidgetSettingsContainer } from "./__styles__/WidgetSettings";
import {
  CreatorPermissionsConfig,
  DisplaySettingsSection,
  FieldSettingConfig,
  ViewerPermissionsConfig,
} from "./shared";

const UniqueIdFieldSettings = (
  props: SelectedSubmissionsBuilderField & SubmissionsBuilderFieldSettings,
) => {
  const { fieldPath, isModuleInput, readOnly } = props;
  const { register, control } =
    useFormContext<SubmissionsBuilderFormDataStructure>();

  return (
    <WidgetSettingsContainer>
      <FieldSettingConfig
        fieldPath={fieldPath}
        isModuleInput={isModuleInput}
        isFormulaField={false}
        readOnly={readOnly}
        requiredFieldDisabled={true}
      />
      <div>
        <Label text={"Helper text"} htmlFor={`${fieldPath}.helperText`} />
        <Text {...register(`${fieldPath}.helperText`)} disabled={readOnly} />
      </div>
      <div>
        <Label text={"Placeholder text"} htmlFor={`${fieldPath}.placeholder`} />
        <Text {...register(`${fieldPath}.placeholder`)} disabled={true} />
      </div>
      <div>
        <Label
          text={"Unique id prefix"}
          description="Optional text to add a prefix before the ID like PDA- or {{year}}"
          htmlFor={`${fieldPath}.uniqueIdPrefix`}
        />
        <Text {...register(`${fieldPath}.prefix`)} disabled={readOnly} />
      </div>
      <div>
        <Label text="Number type" htmlFor={`${fieldPath}.numberType`} />
        <Radio
          control={control}
          name={`${fieldPath}.numberType`}
          disabled={readOnly}
          options={[
            { value: "ascending", text: "Ascending order" },
            { value: "random", text: "Randomized" },
          ]}
        />
      </div>

      <FormSection>
        <FormSectionTitleWrapper>
          <Title size="small" type="semiBold">
            Permissions and defaults
          </Title>
        </FormSectionTitleWrapper>
        <CreatorPermissionsConfig
          fieldPath={fieldPath}
          label="Who can view this field during creation?"
        />
        <ViewerPermissionsConfig fieldPath={fieldPath} />
      </FormSection>
      <DisplaySettingsSection fieldPath={fieldPath} readOnly={readOnly} />
    </WidgetSettingsContainer>
  );
};

UniqueIdFieldSettings.displayName = "UniqueIdFieldSettings";

export default UniqueIdFieldSettings;
